import type { ComponentWithAs, IconProps } from '@chakra-ui/react';
import { Flex, Button, Box, Text } from '@chakra-ui/react';

interface IExtraServiceCardProps {
  btnLabel: string;
  desc: string;
  icon: ComponentWithAs<'svg', IconProps>;
  isVisible?: boolean;
  label: string;
  name: string;
  onClick: () => void;
}

export const ExtraServiceCard: React.FC<IExtraServiceCardProps> = ({
  btnLabel,
  desc,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  icon: Icon,
  isVisible,
  label,
  name,
  onClick,
}): JSX.Element => {
  if (!isVisible) {
    return <div></div>;
  }

  return (
    <Flex
      _hover={{ cursor: 'pointer', boxShadow: 'lg' }}
      alignItems="center"
      boxShadow="md"
      direction="column"
      minH={300}
      p={4}
      position="relative"
      textAlign="center"
    >
      <Box
        bg="brand.black"
        color="white"
        left="-5px"
        position="absolute"
        px={8}
        py={1}
        textTransform="uppercase"
        top={4}
      >
        <Text>{label}</Text>
      </Box>
      <Icon h={20} mb={6} mt={14} w={20} />
      <Text fontSize="h4" fontWeight="bold">
        {name}
      </Text>
      <Text fontSize="small">{desc}</Text>
      <Button fontSize="normal" fontWeight="normal" variant="link" onClick={onClick}>
        {btnLabel}
      </Button>
    </Flex>
  );
};
